/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import { connect } from "react-redux";
import Modal from "modules/common/components/Modal";
import withForm from 'modules/common/hoc/withForm';
import { ModalContext } from "App";
import { formatedSelectOption, omitEmptyArgs } from "helper";
import Select from "react-select";
import PropTypes from "prop-types";
import Alert from "react-s-alert";
import * as actions from "../action";
import * as c from "../constant";

function DepreciationRateModal({
  createData,
  type,
  dataInfo,
  updateData,
  history,
  getList,
  showData,
  createInput,
  createTelephoneNumber,
  createTinNumber,
  formData,
  setFormData,
  id,
}) {
  const setModal = useContext(ModalContext);
  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (type === 'NEW') {
      createData(omitEmptyArgs(formData), (data) => {
        setModal({ isOpen: false });
        getList();
        history.push(
          `/rpt/machinery/machinery-settings/depreciation-rates/${data.data.id}`
        );
        showData(data.data.id);
      });
    }

    if (type === 'EDIT') {
      updateData(id, omitEmptyArgs(formData), (data) => {
        setModal({ isOpen: false });
        getList();
        history.push(
          `/rpt/machinery/machinery-settings/depreciation-rates/${data.data.id}`
        );
        showData(data.data.id);
      });
    }

  };

  const handleOnClose = (e) => {
    if (e) e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    if (type === "EDIT") {
      setFormData({
        ...formData,
        depreciation_rate: _.get(dataInfo, 'depreciation_rate'),
        from: _.get(dataInfo, 'from'),
        to: _.get(dataInfo, 'to'),
      });
    }
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className='row'>
          <div className='col-12 form-group'>
            {createInput(
              { key: 'depreciation_rate', label: 'Depreciation Rate:' },
              { required: true, type: 'number' }
            )}
          </div>
          <div className='col-6 form-group'>
            {createInput(
              { key: 'from', label: 'From:' },
              { required: true }
            )}
          </div>
          <div className='col-6 form-group'>
            {createInput(
              { key: 'to', label: 'To:' },
              { required: true }
            )}
          </div>
        </div>
        <div className='d-flex justify-content-center mt-4'>
          <button type='submit' className='btn btn-md btn-primary cms-bg-color-primary cms-outline-primary  mr-1 cms-bg-color-primary'>
            Submit
          </button>
          <button
            type='button'
            onClick={handleOnClose}
            className='btn btn-light ml-1'
          >
            Cancel
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

DepreciationRateModal.defaultProps = {
  type: '',
  dataInfo: {},
  id: '',
};

DepreciationRateModal.propTypes = {
  createData: PropTypes.instanceOf(Function).isRequired,
  updateData: PropTypes.instanceOf(Function).isRequired,
  type: PropTypes.string,
  history: PropTypes.instanceOf(Object).isRequired,
  dataInfo: PropTypes.instanceOf(Object),
  getList: PropTypes.instanceOf(Function).isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  createTelephoneNumber: PropTypes.instanceOf(Function).isRequired,
  createTinNumber: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.number,
};

const mapStateToProps = () => ({
});

const enhance = _.flowRight([
  withRouter,
  withForm,
  connect(mapStateToProps, actions),
]);

export default enhance(DepreciationRateModal);
